export enum PatientDataRequestStatus {
    open = 'open',
    processed = 'processed',
}
